module.exports = __webpack_public_path__ + "static/19-5c7c7c750a2e1b9c4913f702582b9b96.jpg";